import React from 'react';
import {Icon, Tooltip, HStack, Text} from '@chakra-ui/react';
import {Warning} from '@carbon/icons-react';
import _ from 'lodash';

const formatValue = (value: unknown): string => {
  if (_.isArray(value)) {
    return value.join(', ');
  }
  if (_.isNumber(value)) {
    return value.toLocaleString();
  }
  return _.toString(value);
};

export const BuilderPreviewValue = ({
  value,
  isStale,
}: {
  value: unknown;
  isStale?: boolean;
}) => {
  return (
    <HStack spacing={4} alignItems="flex-start">
      <Text>{formatValue(value)}</Text>
      {isStale && (
        <Tooltip
          label="Value is outdated, run preview to refresh"
          placement="left"
        >
          <Icon
            as={Warning}
            color="kred.400"
            boxSize="16px"
            flexShrink={0}
            mt="2px"
          />
        </Tooltip>
      )}
    </HStack>
  );
};
